import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { LeaderboardHeaderComponent } from './leaderboard-header/leaderboard-header.component';
import { LeaderboardContentComponent } from './leaderboard-content/leaderboard-content.component';
import { IAssignment } from 'src/app/interfaces/leaderboard/iassignment';
import { ISimulation } from 'src/app/interfaces/leaderboard/isimulation';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'leaderboard',
    },
  ],
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    LeaderboardHeaderComponent,
    LeaderboardContentComponent,
  ],
})
export class LeaderboardComponent implements OnInit {
  isTranslationLoaded: boolean = false;
  selectedAssignment: IAssignment | null = null;
  selectedSimulation: ISimulation | null = null;

  constructor(
    private translationService: TranslationService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit(): void {
    this.translationService.loadScopedTranslation('leaderboard').then(() => {
      this.isTranslationLoaded = true;
    });

    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.LEADERBOARD_PAGEVIEW
    );
  }

  onAssignmentSelected(assignment: IAssignment | null): void {
    this.selectedAssignment = assignment;
    if (!assignment) {
      this.selectedSimulation = null;
    }
  }

  onSimulationSelected(simulation: ISimulation | null): void {
    this.selectedSimulation = simulation;
  }
}
